import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'analytics';

export const LOADING_COMPLETE = `${NAMESPACE}/LOADING_COMPLETE`;

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const LOAD_INIT_DATA = createApiNamespacedConstants('LOAD_INIT_DATA');
export const GET_ORGANIZATION = createApiNamespacedConstants('GET_ORGANIZATION');
